<template>
  <div class="megamenu-row">
    <slot />
  </div>
</template>
